// extracted by mini-css-extract-plugin
module.exports = {"container":"AthletesStats_container__V3f4x","supline":"AthletesStats_supline__rEUFm","h2":"AthletesStats_h2__kv_GA","subtitle":"AthletesStats_subtitle__NTIG_"};